import React, { Component } from 'react';

import {
  Block,
  Content,
  Footer,
} from 'components/landing/components';

export class FooterBlock extends Component {
  render() {
    return (
      <React.Fragment>
        <Block modifier="footer">
          <Content>
            <Footer />
          </Content>
        </Block>
      </React.Fragment>
    );
  }
}

export default FooterBlock;



// WEBPACK FOOTER //
// ./src/components/landing/components/footerBlock/FooterBlock.js